//DOMESTIC SIGNAL
export const faCols_domesticMarketTopPriceChanges = {
  // id: "ردیف",
  symbol: "نماد",
  industry: "صنعت",
  commodity_type: "نوع کالا",
  commodity: "کالا",
  producer: "تولید کننده",
  domestic_mean: "میانگین قیمت (میلیون تومان)",
  last_price_date: "تاریخ آخرین قیمت",
  domestic_last_price: "آخرین قیمت (میلیون تومان)",
  deviation: "انحراف آخرین قیمت از میانگین (درصد)",
  commodity_sell_percent: "نسبت فروش محصول از کل فروش تولید کننده (درصد)",
  commodity_value_total: "ارزش فروش محصول (میلیارد تومان)",
  producer_value_total: "کل فروش تولید کننده (میلیارد تومان)",
  unit: "واحد",
};

//GLOBAL SIGNAL
export const faCols_globalMarketTopPriceChanges = {
  // id: "ردیف",
  industry: "صنعت",
  commodity_type: "نوع کالا",
  commodity: "کالا",
  transit: "حمل و نقل",
  global_mean: "میانگین قیمت (دلار)",
  last_price_date: "تاریخ آخرین قیمت",
  global_last_price: "آخرین قیمت (دلار)",
  deviation: "انحراف آخرین قیمت از میانگین (درصد)",
};

//ROI
export const faCols_roiStock = {
  // id: "ردیف",
  symbol: "نماد",
  daily_roi: "عملکرد روز",
  weekly_roi: "عملکرد هفتگی",
  monthly_roi: "عملکرد ماهانه",
  quarterly_roi: "عملکرد سه ماهه",
  half_yearly_roi: "عملکرد شش ماهه",
  yearly_roi: "عملکرد سالانه",
  three_years_roi: "عملکرد سه ساله",
  market_cap: "ارزش بازار (میلیارد تومان)",
  pe: "P/E",
  sector_pe: "P/E گروه",
  ps: "P/S",
};

//ROI ITEMS
export const faCols_roiIndustryStocks = {
  // id: "ردیف",
  symbol: "نماد",
  daily_roi: "عملکرد روز",
  weekly_roi: "عملکرد هفتگی",
  monthly_roi: "عملکرد ماهانه",
  quarterly_roi: "عملکرد سه ماهه",
  half_yearly_roi: "عملکرد شش ماهه",
  yearly_roi: "عملکرد سالانه",
  three_years_roi: "عملکرد سه ساله",
  pe: "P/E",
  sector_pe: "P/E گروه",
  ps: "P/S",
  market_cap: "ارزش بازار (میلیارد تومان)",
};

//MARKET WATCH
export const MarketWatchHeaderName = {
  // id: "ردیف",
  symbol: "نماد",
  last_time: "آخرین معامله",
  buy_pressure: "شاخص قدرت خرید",
  trade_count: "تعداد معاملات",
  volume: "حجم (میلیون)",
  value: "ارزش روز (میلیارد تومان)",
  name: "نام شرکت",
  closing_price: "پایانی (ریال)",
  closing_price_change: "تغییرات پایانی (درصد)",
  last_price: "آخرین (ریال)",
  last_price_change: "تغییرات آخرین (درصد)",
  money_flow: "ورود پول (میلیارد تومان)",
  buy_value: "ارزش خرید (میلیارد تومان)",
  buy_ratio: "نسبت خرید",
  sell_ratio: "نسبت فروش",
  monthly_price_spread: "اسپرد قیمت ماهانه (درصد)",
  mean: "میانگین ارزش (میلیارد تومان)",
  value_change: "نسبت تغییر",
  last_update: "آخرین معامله",
  buy_order_value: "ارزش سفارش‌های خرید",
  sell_order_value: "ارزش سفارش‌های فروش",
};

//HISTORY
export const HistoryHeaderName = {
  asset_name: "سهم",
  close_price: "پایانی (ریال)",
  date: "تاریخ",
  expiration_date: "تاریخ اعمال",
  first_price: "اولین (ریال)",
  last_trade: "آخرین (ریال)",
  premium_strike: "قیمت اعمال + پریمیوم (ریال)",
  price_max: "حداکثر (ریال)",
  price_min: "حداقل (ریال)",
  quantity: "تعداد",
  strike: "قیمت اعمال (ریال)",
  symbol: "نماد",
  volume: "حجم",
  value: "ارزش (میلیارد تومان)",
  yesterday_price: "دیروز (ریال)",
  equit_close_price: "پایانی سهم (ریال)",
};

//SPREAD PRICE
export const SpreadPriceHeaderName = {
  // id: "ردیف",
  asset_name: "سهام",
  symbol: "نماد اختیار",
  strike: "قیمت اعمال",
  base_equit_price: "آخرین سهم (ریال)",
  last_update: "آخرین اطلاعات نماد اختیار",
  price_spread: "اسپرد قیمتی (درصد)",
  days_to_expire: "روزهای باقیمانده",
  // monthly_price_spread: "اسپرد قیمتی ماهانه (درصد)",
  expiration_date: "تاریخ اعمال",
  option_type: "نوع اختیار",
  value: "ارزش معاملات نماد اختیار (میلیون تومان)",
  premium: "پرمیوم (ریال)",
  strike_premium: "قیمت اعمال + پرمیوم (ریال)",
};

//OPTION VOLUME CHANGE
export const OptionValueChangeHeaderName = {
  // id: "ردیف",
  symbol: "نماد",
  last_update: "آخرین معامله",
  last_mean: "میانگین ارزش نمادهای اختیار امروز (میلیون تومان)",
  month_mean: "میانگین ارزش نمادهای اختیار ماه (میلیون تومان)",
  value_change: "نسبت تغییر",
  daily_roi: "عملکرد روز (درصد)",
  pe: "P/E",
  sector_pe: "P/E گروه",
  ps: "P/S",
  market_cap: "ارزش بازار (میلیارد تومان)",
};

//RECOMMENDED
export const RecommendedHeaderName = {
  // id: "ردیف",
  symbol: "نماد",
  total_score: "امتیاز کل",
  money_flow: "ورود پول (میلیارد تومان)",
  money_flow_score: "امتیاز",
  buy_pressure: "قدرت خرید",
  buy_pressure_score: "امتیاز",
  buy_value: "خرید درشت (میلیارد تومان)",
  buy_value_score: "امتیاز",
  buy_ratio: "درصد نسبت خرید",
  buy_ratio_score: "امتیاز",
  sell_ratio: "درصد نسبت فروش",
  sell_ratio_score: "امتیاز",
  roi: "درصد بازدهی دوره",
  roi_score: "امتیاز",
  value_change: "درصد تغییر ارزش معاملات",
  value_change_score: "امتیاز",
  call_value_change: "درصد تغییر ارزش اختیارهای خرید",
  call_value_change_score: "امتیاز",
  put_value_change: "درصد تغییر ارزش اختیارهای فروش",
  put_value_change_score: "امتیاز",
  option_price_spread: "درصد شاخص اسپرد قیمتی",
  option_price_spread_score: "امتیاز",
  global: "بازار جهانی",
  global_score: "امتیاز جهانی",
  domestic: "بازار داخلی",
  domestic_score: "امتیاز داخلی",
};

//FUTURE
export const FutureContractHeaderName = {
  base_equity_last_price: "آخرین دارایی پایه (ریال)",
  base_equity_name: "دارایی پایه",
  best_buy_price: "بهترین قیمت خرید",
  best_sell_price: "بهترین قیمت فروش",
  derivative_name: "نام قرارداد مشتقه",
  expiration_date: "تاریخ سررسید",
  monthly_spread: "اسپرد ماهانه",
  remained_day: "روزهای باقی مانده",
  strategy: "موقعیت",
  total_spread: "اسپرد کل",
  base_equity_value: "ارزش معاملات دارایی پایه (میلیارد تومان)",
  contract_size: "اندازه قرارداد",
  derivative_value: "ارزش معاملات نماد (میلیارد تومان)",
  initial_margin: "وجه تضمین اولیه (ریال)",
  last_settlement_price: "قیمت تسویه روزانه (ریال)",
  open_interests: "قراردادهای باز",
  today_settlement_price: "قیمت لحظه‌ای تسویه (ریال)",
  derivative_last_update: "آخرین معامله",
  base_equity_last_update: "آخرین معامله",
};

//FUTURE STRATEGIES
export const FutureStrategiesHeaderName = {
  contract_size: "اندازه قرارداد",
  start_date: "تاریخ شروع",
  end_date: "تاریخ اعمال",
  strike_price: "قیمت اعمال (ریال)",
  remained_day: "روزهای باقیمانده",
  base_equity_ins_code: "کد سهم",
  base_equity_symbol: "نماد سهم",
  base_equity_close_price: "پایانی سهم (ریال)",
  base_equity_yesterday_price: "دیروز سهم (ریال)",
  base_equity_last_price: "آخرین سهم (ریال)",
  base_equity_best_sell_price: "(ریال) بهترین قیمت فروش سهم",
  base_equity_best_sell_volume: "بهترین حجم فروش سهم",
  call_ins_code: "کد (اختیارخ)",
  call_last_price: "آخرین اختیارخ (ریال)",
  call_open_position_count: "تعداد قراردادهای باز (اختیارخ)",
  call_close_price: "پایانی اختیارخ (ریال)",
  call_yesterday_price: "دیروز اختیارخ (ریال)",
  call_notional_value: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_value: "ارزش اختیارخ (میلیارد تومان)",
  call_volume: "حجم (اختیارخ)",
  call_quantity: "تعداد (اختیارخ)",
  call_name: "نام (اختیارخ)",
  call_symbol: "نماد (اختیارخ)",
  call_best_buy_price: "بهترین قیمت خرید اختیارخ (ریال)",
  call_best_buy_volume: "بهترین حجم خرید اختیارخ",
  call_best_sell_price: "بهترین قیمت فروش اختیارخ (ریال)",
  call_best_sell_volume: "بهترین حجم فروش اختیارخ",
  call_yesterday_open_position_count: "قراردادهای باز دیروز (اختیارخ)",
  call_buy_symbol: "خرید نماد (اختیارخ)",
  call_buy_name: "خرید اختیارخ",
  call_sell_symbol: "فروش نماد (اختیارخ)",
  call_sell_name: "فروش اختیارخ",
  call_buy_symbol_low: "خرید نماد (اختیارخ)",
  call_buy_symbol_mid: "خرید نماد (اختیارخ)",
  call_sell_symbol_high: "فروش نماد (اختیارخ)",
  call_sell_symbol_low: "فروش نماد (اختیارخ)",
  call_buy_name_low: "خرید اختیارخ",
  call_sell_name_low: "فروش اختیارخ",
  call_buy_name_mid: "خرید اختیارخ",
  call_sell_name_high: "فروش اختیارخ",
  call_best_sell_price_low: "بهترین قیمت فروش (اختیارخ)",
  call_best_sell_price_mid: "بهترین قیمت فروش (اختیارخ)",
  call_best_buy_price_low: "بهترین قیمت خرید (اختیارخ)",
  call_best_buy_price_high: "بهترین قیمت خرید (اختیارخ)",
  call_sell_symbol_mid: "فروش نماد (اختیارخ)",
  call_sell_name_mid: "فروش اختیارخ",
  call_best_buy_price_mid: "بهترین قیمت خرید (اختیارخ)",
  call_buy_symbol_high: "خرید نماد (اختیارخ)",
  call_buy_name_high: "خرید اختیارخ",
  call_best_sell_price_high: "بهترین قیمت فروش (اختیارخ)",
  put_ins_code: "کد (اختیارف)",
  put_symbol: "نماد (اختیارف)",
  put_name: "نام (اختیارف)",
  put_quantity: "تعداد (اختیارف)",
  put_volume: "حجم (اختیارف)",
  put_value: "ارزش اختیارف (میلیارد تومان)",
  put_notional_value: "ارزش مفهومی اختیارف (میلیارد تومان)",
  put_close_price: "پایانی اختیارف (ریال)",
  put_yesterday_price: "دیروز اختیارف (ریال)",
  put_open_position_count: "تعداد قراردادهای باز (اختیارف)",
  put_last_price: "آخرین اختیارف (ریال)",
  put_best_buy_price: "بهترین قیمت خرید اختیارف (ریال)",
  put_best_buy_volume: "بهترین حجم خرید اختیارف",
  put_best_sell_price: "بهترین قیمت فروش اختیارف (ریال)",
  put_best_sell_volume: "بهترین حجم فروش اختیارف",
  put_yesterday_open_position_count: "قراردادهای باز دیروز (اختیارف)",
  put_buy_symbol: "خرید نماد (اختیارف)",
  put_buy_name: "خرید اختیارف",
  put_sell_symbol: "فروش نماد (اختیارف)",
  put_sell_name: "فروش اختیارف",
  final_profit: "نهایی (درصد)",
  monthly_profit: "ماهانه (درصد)",
  yearly_profit: "سالانه (درصد)",
  call_buy_strike: "قیمت اعمال (ریال)",
  call_sell_strike: "قیمت اعمال (ریال)",
  put_buy_strike: "قیمت اعمال (ریال)",
  put_sell_strike: "قیمت اعمال (ریال)",
  call_buy_strike_low: "قیمت اعمال (ریال)",
  call_sell_strike_mid: "قیمت اعمال (ریال)",
  call_buy_strike_high: "قیمت اعمال (ریال)",
  call_best_sell_volume_low: "بهترین حجم فروش اختیارخ (ریال)",
  call_best_buy_volume_mid: "بهترین حجم خرید اختیارخ (ریال)",
  call_best_sell_volume_high: "بهترین حجم فروش اختیارخ (ریال)",
  call_sell_strike_low: "قیمت اعمال (ریال)",
  call_buy_strike_mid: "قیمت اعمال (ریال)",
  call_sell_strike_high: "قیمت اعمال (ریال)",
  call_best_buy_volume_low: "بهترین حجم خرید اختیارخ (ریال)",
  call_best_sell_volume_mid: "بهترین حجم فروش اختیارخ (ریال)",
  call_best_buy_volume_high: "بهترین حجم خرید اختیارخ (ریال)",
  base_equity_value: "ارزش معاملات (میلیارد تومان)",
  call_buy_notional_value: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_sell_notional_value: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  put_buy_notional_value: "ارزش مفهومی اختیارف (میلیارد تومان)",
  put_sell_notional_value: "ارزش مفهومی اختیارف (میلیارد تومان)",
  call_buy_notional_value_low: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_buy_notional_value_mid: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_buy_notional_value_high: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_sell_notional_value_low: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_sell_notional_value_mid: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_sell_notional_value_high: "ارزش مفهومی اختیارخ (میلیارد تومان)",
  call_buy_value: "ارزش اختیارخ (میلیارد تومان)",
  call_sell_value: "ارزش اختیارخ (میلیارد تومان)",
  put_buy_value: "ارزش اختیارف (میلیارد تومان)",
  put_sell_value: "ارزش اختیارف (میلیارد تومان)",
  call_buy_value_low: "ارزش اختیارخ (میلیارد تومان)",
  call_buy_value_mid: "ارزش اختیارخ (میلیارد تومان)",
  call_buy_value_high: "ارزش اختیارخ (میلیارد تومان)",
  call_sell_value_low: "ارزش اختیارخ (میلیارد تومان)",
  call_sell_value_mid: "ارزش اختیارخ (میلیارد تومان)",
  call_sell_value_high: "ارزش اختیارخ (میلیارد تومان)",
  required_change: "تغییر مورد نیاز (درصد)",
  final_break_even: "درصد سربه‌سر",
  monthly_break_even: "سربه‌سر ماهانه",
  yearly_break_even: "سربه‌سر سالانه",
  leverage: "اهرم",
};

//TRANSACTIONS
export const faCols_transition= {
  discount_name: "تخفیف",
  discount_percent: "تخفیف %",
  feature_duration: "مدت اشتراک (ماه)",
  feature_login_count: "تعداد کاربر همزمان",
  feature_name: "نام اشتراک",
  is_confirmed: "پرداخت",
  method_name: "درگاه پرداخت",
  price: "قیمت (تومان)",
  tracking_id: "کد رهگیری",
  updated_at: "تاریخ"
}